import { call, takeLatest } from 'redux-saga/effects';
import actionTypes from '../../actions/actionTypes';
import { getNewsletterDataCall } from '../../apis/wpApi/apiCalls';
import { putSuccess, putError } from '../helpers'
import authUser from '../../apis/wpApi/authUser';

function* getData({payload}) {
    try {
        const apiKey = yield call(authUser.getToken)
        const response = yield call(getNewsletterDataCall, apiKey, payload.signal)        

        if(!response || !response.status || 200 !== response.status || !response.data ) {
            throw new Error('Could not update data')
        } else {
            yield putSuccess(actionTypes.NEWSLETTER_GET_SUCCESS, response.data)
        }
    } catch(e) {
        console.log('ERROR', e)
        yield putError(actionTypes.NEWSLETTER_GET_ERROR, e.message)
    }
}

function* watchNewsletterGetRequest() {
    yield takeLatest(actionTypes.NEWSLETTER_GET_REQUEST, getData);
}

export default watchNewsletterGetRequest